define('HomeFeaturedProducts.View', [
    'SC.Configuration',
    'HomeFeaturedProducts.Slider.View',
    'home_featured_products.tpl',
    'Item.Model',
    'Item.Collection',
    'Backbone',
    'Profile.Model',
    'jQuery',
    'Utils',
    'underscore'
], function HomeFeaturedProductsView(
    Configuration,
    HomeFeaturedProductsSliderView,
    homeFeaturedProductsTpl,
    ItemModel,
    ItemCollection,
    Backbone,
    Profile,
    jQuery,
    Utils,
    _
) {
    'use strict';

    return Backbone.View.extend({
        actualFilter: 'all',
        sliderInstance: null,
        template: homeFeaturedProductsTpl,
        initialize: function initialize(options) {
            this.application = options.application;
            this.config = JSON.parse(JSON.stringify(options.config));
            this.filters = this.config.filters || [];
            this.filters.unshift({type: 'all', name: 'All'});
            this.filters = _.uniq(this.filters, 'type');
        },
        events: {
            'click [data-toggle="filter"]': 'applyFilter'
        },
        applyFilter: function applyFilter(e) {
            var $target = jQuery(e.currentTarget);
            var type = $target.data('type');
            var filter = _.findWhere(this.filters, {
                type: type
            });
            this.$('.featured-products-filter')
                .removeClass('active')
                .attr('aria-selected', 'false');
            $target
                .addClass('active')
                .attr('aria-selected', 'true');

            Backbone.Events.trigger('HomeFeaturedFilterChange', filter);
        },
        childViews: {
            'ProductSlider': function productSliderChildView() {
                return new HomeFeaturedProductsSliderView({
                    application: this.application,
                    config: this.config
                })
            }
        },
        getContext: function getContext() {
            var profile = Profile.getInstance();
            var store = profile.get('store');
            var storeName = (store && store.get('name')) ? store.get('name') : null;
            var activeType = 'all';

            return {
                filters: this.filters,
                actualFilter: this.actualFilter,
                activeType: activeType,
                featuresLink: storeName ? '/custitem_awa_show_on_home_by_store/' + storeName.replace(/ /gi, '-') : 'custitem_home_featured_item/T'
            };
        }
    });
});
